// extracted by css-extract-rspack-plugin
export default {"cls1":"SplitVerdictPreviewList-cls1_nDT","cls2":"SplitVerdictPreviewList-cls2_qKs SplitVerdictPreviewList-cls1_nDT"};